export default "__VITE_ASSET__MJY2rGlt__"